<template>
  <b-alert
    v-if="duplicate && duplicate.duplicate"
    show
    variant="warning"
    class="sli-dup"
  >
    <h5 class="alert-heading mb-1">
      يوجد سجل مطابق
    </h5>
    <p class="mb-50">
      سبب المطابقة:
      <strong>{{ reasonLabel }}</strong>
    </p>
    <p
      v-if="matched"
      class="mb-1"
    >
      السجل: {{ matched.subject_name || '—' }}
      <span v-if="matched.shahr_number"> — شهر {{ matched.shahr_number }}</span>
      <span v-if="matched.land_code"> — كود {{ matched.land_code }}</span>
      <span v-if="matched.id"> — رقم {{ matched.id }}</span>
    </p>
    <div class="d-flex flex-wrap" style="gap: 8px;">
      <b-button
        v-if="matched && matched.id"
        variant="outline-primary"
        @click="$emit('open-existing', matched.id)"
      >
        فتح السجل الموجود
      </b-button>
      <b-button
        variant="warning"
        @click="$emit('save-update')"
      >
        حفظ بالتحديث
      </b-button>
    </div>
  </b-alert>
</template>

<script>
import { BAlert, BButton } from 'bootstrap-vue'

export default {
  name: 'SliDuplicateWarning',
  components: { BAlert, BButton },
  props: {
    duplicate: { type: Object, default: null },
  },
  computed: {
    matched() {
      return this.duplicate && this.duplicate.inventory ? this.duplicate.inventory : null
    },
    reasonLabel() {
      const reason = this.duplicate && this.duplicate.match_reason
      if (reason === 'land_code') return 'كود الأرض'
      if (reason === 'cadastral_identity') return 'الهوية المساحية (محافظة + مركز + ناحية + رقم قطعة)'
      return reason || 'مطابقة'
    },
  },
}
</script>
